function SingleChoiceIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <circle cx='16.5' cy='16' r='13' stroke='currentColor' fill='none' strokeWidth='2' />
        <circle cx='16.5' cy='16' r='9' fill='currentColor' />
      </svg>
    </span>
  );
}

export default SingleChoiceIcon;
